




















































import { Component, Vue } from "vue-property-decorator";
import { ServerResult } from "@/core/http/server_result";

const LIST_OP = "PRODUCT_TYPE_FORECAST_GROUPS";

@Component
export default class ProductTypeForecastGroupForm extends Vue {
  loading = true;
  saving = false;
  fatalError = false;
  rows: any[] = [];

  created() {
    this.load();
  }

  load() {
    this.loading = true;
    this.fatalError = false;

    (this as any)
      .$db([
        (this as any)
          .$q(LIST_OP)
          .raw("production_forecast_daily_product_types")
          .action({})
      ])
      .then((result: ServerResult) => {
        const content = result.getOperation(LIST_OP).getContent() || {};
        this.rows = (content.items || []).map((item: any) => ({
          id: item.id,
          name: item.name,
          forecast_group: item.forecast_group === "sauce" ? "sauce" : "cheese"
        }));
      })
      .catch((error: any) => {
        this.fatalError = true;
        this.rows = [];
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.error("[FIX] ProductTypeForecastGroupForm load failed", error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  save() {
    this.saving = true;

    (this as any).$http
      .post(
        "/api/v1/production_forecast_daily/product_type_groups",
        {
          entries: this.rows.map((row) => ({
            id: row.id,
            forecast_group: row.forecast_group
          }))
        },
        {}
      )
      .then(() => {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.log("[FIX] ProductTypeForecastGroupForm saved", {
            types: this.rows.length
          });
        }
        this.$buefy.toast.open({ message: "Сохранено", type: "is-success" });
        this.$emit("saved");
        this.$emit("close");
      })
      .catch((error: any) => {
        this.$buefy.toast.open({
          message: error?.message || "Ошибка сохранения",
          type: "is-danger"
        });
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
